import moment from 'moment';

const today = moment().format('YYYY-MM-DD');

export const testAppointmentsVerdonk = [
  {
    'id': '4433223',
    'campus': {
      'id': '3',
      'name': 'Campus Antwerpen',
      'address': 'Harmoniestraat 68, 2018 Antwerpen',
      'isAvailableQR': false
    },
    'dateTime': `${moment().format('YYYY-MM-DD')}T16:50:00Z`,
    'createdDateTime': `${moment().format('YYYY-MM-DD')}T10:08:27.273Z`,
    'patient': {
      'id': '34bff3ab-3e07-4e56-a2ab-1c0232116582',
      'externalId': '37783',
      'firstName': 'Dennis',
      'lastName': 'Heirman',
      'isNew': false,
      'isUmbi': true,
      'status': 'Validated',
      'isDeleted': false,
      'gender': 'Male',
      'birthDate': '1983-05-18T00:00:00'
    },
    'creator': {
      'id': '503',
      'firstName': 'Farida',
      'lastName': 'Ghannouti'
    },
    'practitioner': {
      'id': 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      'photo': 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      'localizations': [
        {
          'lang': 'en',
          'name': 'Prof. Dr. Peter Verdonk'
        },
        {
          'lang': 'nl',
          'name': 'Prof. Dr. Peter Verdonk'
        }
      ],
      'specialties': [
        {
          'id': '629e7f91-18d8-4f1f-8567-259b6cf03cf6',
          'translations': {
            'en': 'Knee',
            'nl': 'Knie'
          }
        },
        {
          'id': 'cf611fec-ab40-4326-a845-6b1d18c9388b',
          'translations': {
            'nl': 'Sportletsels',
            'en': 'Sports injuries'
          }
        }
      ]
    },
    'appointmentType': 'Conscon',
    'note': '',
    'appointment': {
      'triggerInfo': {
        'succeeded': true,
        'triggers': [
          'patient_arrive'
        ]
      },
      'entity': {
        'id': 2114,
        'externalAppointmentId': '4433223',
        'type': 'AppointmentWorkflow',
        'state': 'consultation_booked',
        'additional': {
          'canCancel': false,
          'canReschedule': false
        }
      },
      'viewModel': {
        'id': 2114,
        'state': 'consultation_booked',
        'isOngoing': false
      }
    },
    'isFeedback': false
  },
  {
    'id': '4433224',
    'campus': {
      'id': '9',
      'name': 'Private Campus Kielse Vest',
      'address': 'Kielsevest 14, 2018 Antwerpen',
      'isAvailableQR': false
    },
    'dateTime': `${moment().format('YYYY-MM-DD')}T15:20:00Z`,
    'createdDateTime': `${moment().format('YYYY-MM-DD')}T10:09:29.083Z`,
    'patient': {
      'id': '34bff3ab-3e07-4e56-a2ab-1c0232116582',
      'externalId': '37783',
      'firstName': 'Dennis',
      'lastName': 'Heirman',
      'isNew': false,
      'isUmbi': true,
      'status': 'Validated',
      'isDeleted': false,
      'gender': 'Male',
      'birthDate': '1983-05-18T00:00:00'
    },
    'creator': {
      'id': '503',
      'firstName': 'Farida',
      'lastName': 'Ghannouti'
    },
    'practitioner': {
      'id': 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      'photo': 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      'localizations': [
        {
          'lang': 'en',
          'name': 'Prof. Dr. Peter Verdonk'
        },
        {
          'lang': 'nl',
          'name': 'Prof. Dr. Peter Verdonk'
        }
      ],
      'specialties': [
        {
          'id': '629e7f91-18d8-4f1f-8567-259b6cf03cf6',
          'translations': {
            'en': 'Knee',
            'nl': 'Knie'
          }
        },
        {
          'id': 'cf611fec-ab40-4326-a845-6b1d18c9388b',
          'translations': {
            'nl': 'Sportletsels',
            'en': 'Sports injuries'
          }
        }
      ]
    },
    'appointmentType': 'Conscon',
    'note': '',
    'appointment': {
      'triggerInfo': {
        'succeeded': true,
        'triggers': [
          'patient_arrive'
        ]
      },
      'entity': {
        'id': 2115,
        'externalAppointmentId': '4433224',
        'type': 'AppointmentWorkflow',
        'state': 'consultation_booked',
        'additional': {
          'canCancel': false,
          'canReschedule': false
        }
      },
      'viewModel': {
        'id': 2115,
        'state': 'consultation_booked',
        'isOngoing': false
      }
    },
    'isFeedback': false
  },
  {
    'id': '4433225',
    'campus': {
      'id': '9',
      'name': 'Private Campus Kielse Vest',
      'address': 'Kielsevest 14, 2018 Antwerpen',
      'isAvailableQR': false
    },
    'dateTime': `${moment().format('YYYY-MM-DD')}T10:00:00Z`,
    'createdDateTime': `${moment().format('YYYY-MM-DD')}T10:09:47.033Z`,
    'patient': {
      'id': '34bff3ab-3e07-4e56-a2ab-1c0232116582',
      'externalId': '37783',
      'firstName': 'Dennis',
      'lastName': 'Heirman',
      'isNew': false,
      'isUmbi': true,
      'status': 'Validated',
      'isDeleted': false,
      'gender': 'Male',
      'birthDate': '1983-05-18T00:00:00'
    },
    'creator': {
      'id': '503',
      'firstName': 'Farida',
      'lastName': 'Ghannouti'
    },
    'practitioner': {
      'id': 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      'photo': 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      'localizations': [
        {
          'lang': 'en',
          'name': 'Prof. Dr. Peter Verdonk'
        },
        {
          'lang': 'nl',
          'name': 'Prof. Dr. Peter Verdonk'
        }
      ],
      'specialties': [
        {
          'id': '629e7f91-18d8-4f1f-8567-259b6cf03cf6',
          'translations': {
            'en': 'Knee',
            'nl': 'Knie'
          }
        },
        {
          'id': 'cf611fec-ab40-4326-a845-6b1d18c9388b',
          'translations': {
            'nl': 'Sportletsels',
            'en': 'Sports injuries'
          }
        }
      ]
    },
    'appointmentType': 'Conscon',
    'note': '',
    'appointment': {
      'triggerInfo': {
        'succeeded': true,
        'triggers': [
          'patient_arrive'
        ]
      },
      'entity': {
        'id': 2117,
        'externalAppointmentId': '4433225',
        'type': 'AppointmentWorkflow',
        'state': 'consultation_booked',
        'additional': {
          'canCancel': false,
          'canReschedule': false
        }
      },
      'viewModel': {
        'id': 2117,
        'state': 'consultation_booked',
        'isOngoing': false
      }
    },
    'isFeedback': false
  },
  {
    'id': '4433229',
    'campus': {
      'id': '9',
      'name': 'Private Campus Kielse Vest',
      'address': 'Kielsevest 14, 2018 Antwerpen',
      'isAvailableQR': false
    },
    'dateTime': `${moment().format('YYYY-MM-DD')}T15:00:00Z`,
    'createdDateTime': `${moment().format('YYYY-MM-DD')}T10:11:30.76Z`,
    'patient': {
      'id': 'eb3a3391-192f-4ae8-b859-71511c85a9dd',
      'externalId': '152859',
      'firstName': 'Dario',
      'lastName': 'Cagnazzo',
      'isNew': false,
      'isUmbi': true,
      'status': 'Validated',
      'isDeleted': false,
      'gender': 'Male',
      'birthDate': '1983-05-18T00:00:00'
    },
    'creator': {
      'id': '503',
      'firstName': 'Farida',
      'lastName': 'Ghannouti'
    },
    'practitioner': {
      'id': 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      'photo': 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      'localizations': [
        {
          'lang': 'en',
          'name': 'Prof. Dr. Peter Verdonk'
        },
        {
          'lang': 'nl',
          'name': 'Prof. Dr. Peter Verdonk'
        }
      ],
      'specialties': [
        {
          'id': '629e7f91-18d8-4f1f-8567-259b6cf03cf6',
          'translations': {
            'en': 'Knee',
            'nl': 'Knie'
          }
        },
        {
          'id': 'cf611fec-ab40-4326-a845-6b1d18c9388b',
          'translations': {
            'nl': 'Sportletsels',
            'en': 'Sports injuries'
          }
        }
      ]
    },
    'appointmentType': 'Conscon',
    'note': '',
    'appointment': {
      'triggerInfo': {
        'succeeded': true,
        'triggers': [
          'patient_arrive'
        ]
      },
      'entity': {
        'id': 2118,
        'externalAppointmentId': '4433229',
        'type': 'AppointmentWorkflow',
        'state': 'consultation_booked',
        'additional': {
          'canCancel': false,
          'canReschedule': false
        }
      },
      'viewModel': {
        'id': 2118,
        'state': 'consultation_booked',
        'isOngoing': false
      }
    },
    'isFeedback': false
  },
  {
    'id': '4433230',
    'campus': {
      'id': '3',
      'name': 'Campus Antwerpen',
      'address': 'Harmoniestraat 68, 2018 Antwerpen',
      'isAvailableQR': false
    },
    'dateTime': `${moment().format('YYYY-MM-DD')}T16:20:00Z`,
    'createdDateTime': `${moment().format('YYYY-MM-DD')}T10:11:45.287Z`,
    'patient': {
      'id': 'eb3a3391-192f-4ae8-b859-71511c85a9dd',
      'externalId': '152859',
      'firstName': 'Dario',
      'lastName': 'Cagnazzo',
      'isNew': false,
      'isUmbi': true,
      'status': 'Validated',
      'isDeleted': false,
      'gender': 'Male',
      'birthDate': '1983-05-18T00:00:00'
    },
    'creator': {
      'id': '503',
      'firstName': 'Farida',
      'lastName': 'Ghannouti'
    },
    'practitioner': {
      'id': 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      'photo': 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      'localizations': [
        {
          'lang': 'en',
          'name': 'Prof. Dr. Peter Verdonk'
        },
        {
          'lang': 'nl',
          'name': 'Prof. Dr. Peter Verdonk'
        }
      ],
      'specialties': [
        {
          'id': '629e7f91-18d8-4f1f-8567-259b6cf03cf6',
          'translations': {
            'en': 'Knee',
            'nl': 'Knie'
          }
        },
        {
          'id': 'cf611fec-ab40-4326-a845-6b1d18c9388b',
          'translations': {
            'nl': 'Sportletsels',
            'en': 'Sports injuries'
          }
        }
      ]
    },
    'appointmentType': 'Conscon',
    'note': '',
    'appointment': {
      'triggerInfo': {
        'succeeded': true,
        'triggers': [
          'patient_arrive'
        ]
      },
      'entity': {
        'id': 2120,
        'externalAppointmentId': '4433230',
        'type': 'AppointmentWorkflow',
        'state': 'consultation_booked',
        'additional': {
          'canCancel': false,
          'canReschedule': false
        }
      },
      'viewModel': {
        'id': 2120,
        'state': 'consultation_booked',
        'isOngoing': false
      }
    },
    'isFeedback': false
  },
  {
    'id': '4433234',
    'campus': {
      'id': '9',
      'name': 'Private Campus Kielse Vest',
      'address': 'Kielsevest 14, 2018 Antwerpen',
      'isAvailableQR': false
    },
    'dateTime': `${moment().format('YYYY-MM-DD')}T10:30:00Z`,
    'createdDateTime': `${moment().format('YYYY-MM-DD')}T10:27:14.367Z`,
    'patient': {
      'id': 'eb3a3391-192f-4ae8-b859-71511c85a9dd',
      'externalId': '152859',
      'firstName': 'Dario',
      'lastName': 'Cagnazzo',
      'isNew': false,
      'isUmbi': true,
      'status': 'Validated',
      'isDeleted': false,
      'gender': 'Male',
      'birthDate': '1983-05-18T00:00:00'
    },
    'creator': {
      'id': '503',
      'firstName': 'Farida',
      'lastName': 'Ghannouti'
    },
    'practitioner': {
      'id': 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      'photo': 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      'localizations': [
        {
          'lang': 'en',
          'name': 'Prof. Dr. Peter Verdonk'
        },
        {
          'lang': 'nl',
          'name': 'Prof. Dr. Peter Verdonk'
        }
      ],
      'specialties': [
        {
          'id': '629e7f91-18d8-4f1f-8567-259b6cf03cf6',
          'translations': {
            'en': 'Knee',
            'nl': 'Knie'
          }
        },
        {
          'id': 'cf611fec-ab40-4326-a845-6b1d18c9388b',
          'translations': {
            'nl': 'Sportletsels',
            'en': 'Sports injuries'
          }
        }
      ]
    },
    'appointmentType': 'Conscon',
    'note': '',
    'appointment': {
      'triggerInfo': {
        'succeeded': true,
        'triggers': [
          'patient_arrive'
        ]
      },
      'entity': {
        'id': 2121,
        'externalAppointmentId': '4433234',
        'type': 'AppointmentWorkflow',
        'state': 'consultation_booked',
        'additional': {
          'canCancel': false,
          'canReschedule': false
        }
      },
      'viewModel': {
        'id': 2121,
        'state': 'consultation_booked',
        'isOngoing': false
      }
    },
    'isFeedback': false
  },
  {
    'id': '4433235',
    'campus': {
      'id': '3',
      'name': 'Campus Antwerpen',
      'address': 'Harmoniestraat 68, 2018 Antwerpen',
      'isAvailableQR': false
    },
    'dateTime': `${moment().format('YYYY-MM-DD')}T16:30:00Z`,
    'createdDateTime': `${moment().format('YYYY-MM-DD')}T10:27:40.12Z`,
    'patient': {
      'id': 'd87f493d-5bcb-4650-81fb-f614dd5281bb',
      'externalId': '355920',
      'firstName': 'Youssef',
      'lastName': 'Temsamani Rais',
      'isNew': false,
      'isUmbi': true,
      'status': 'NotValidated',
      'isDeleted': false,
      'gender': 'Male',
      'birthDate': '1983-05-18T00:00:00'
    },
    'creator': {
      'id': '503',
      'firstName': 'Farida',
      'lastName': 'Ghannouti'
    },
    'practitioner': {
      'id': 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      'photo': 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      'localizations': [
        {
          'lang': 'en',
          'name': 'Prof. Dr. Peter Verdonk'
        },
        {
          'lang': 'nl',
          'name': 'Prof. Dr. Peter Verdonk'
        }
      ],
      'specialties': [
        {
          'id': '629e7f91-18d8-4f1f-8567-259b6cf03cf6',
          'translations': {
            'en': 'Knee',
            'nl': 'Knie'
          }
        },
        {
          'id': 'cf611fec-ab40-4326-a845-6b1d18c9388b',
          'translations': {
            'nl': 'Sportletsels',
            'en': 'Sports injuries'
          }
        }
      ]
    },
    'appointmentType': 'Conscon',
    'note': '',
    'appointment': {
      'triggerInfo': {
        'succeeded': true,
        'triggers': [
          'patient_arrive'
        ]
      },
      'entity': {
        'id': 2123,
        'externalAppointmentId': '4433235',
        'type': 'AppointmentWorkflow',
        'state': 'consultation_booked',
        'additional': {
          'canCancel': false,
          'canReschedule': false
        }
      },
      'viewModel': {
        'id': 2123,
        'state': 'consultation_booked',
        'isOngoing': false
      }
    },
    'isFeedback': false
  },
  {
    'id': '4433236',
    'campus': {
      'id': '9',
      'name': 'Private Campus Kielse Vest',
      'address': 'Kielsevest 14, 2018 Antwerpen',
      'isAvailableQR': false
    },
    'dateTime': `${moment().format('YYYY-MM-DD')}T09:00:00Z`,
    'createdDateTime': `${moment().format('YYYY-MM-DD')}T10:27:56.527Z`,
    'patient': {
      'id': 'd87f493d-5bcb-4650-81fb-f614dd5281bb',
      'externalId': '355920',
      'firstName': 'Youssef',
      'lastName': 'Temsamani Rais',
      'isNew': false,
      'isUmbi': true,
      'status': 'NotValidated',
      'isDeleted': false,
      'gender': 'Male',
      'birthDate': '1983-05-18T00:00:00'
    },
    'creator': {
      'id': '503',
      'firstName': 'Farida',
      'lastName': 'Ghannouti'
    },
    'practitioner': {
      'id': 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      'photo': 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      'localizations': [
        {
          'lang': 'en',
          'name': 'Prof. Dr. Peter Verdonk'
        },
        {
          'lang': 'nl',
          'name': 'Prof. Dr. Peter Verdonk'
        }
      ],
      'specialties': [
        {
          'id': '629e7f91-18d8-4f1f-8567-259b6cf03cf6',
          'translations': {
            'en': 'Knee',
            'nl': 'Knie'
          }
        },
        {
          'id': 'cf611fec-ab40-4326-a845-6b1d18c9388b',
          'translations': {
            'nl': 'Sportletsels',
            'en': 'Sports injuries'
          }
        }
      ]
    },
    'appointmentType': 'Conscon',
    'note': '',
    'appointment': {
      'triggerInfo': {
        'succeeded': true,
        'triggers': [
          'patient_arrive'
        ]
      },
      'entity': {
        'id': 2125,
        'externalAppointmentId': '4433236',
        'type': 'AppointmentWorkflow',
        'state': 'consultation_booked',
        'additional': {
          'canCancel': false,
          'canReschedule': false
        }
      },
      'viewModel': {
        'id': 2125,
        'state': 'consultation_booked',
        'isOngoing': false
      }
    },
    'isFeedback': false
  },
  {
    'id': '4433244',
    'campus': {
      'id': '3',
      'name': 'Campus Antwerpen',
      'address': 'Harmoniestraat 68, 2018 Antwerpen',
      'isAvailableQR': false
    },
    'dateTime': `${moment().format('YYYY-MM-DD')}T16:40:00Z`,
    'createdDateTime': `${moment().format('YYYY-MM-DD')}T10:29:46.283Z`,
    'patient': {
      'externalId': '23260',
      'firstName': 'Annick',
      'lastName': 'Willemen',
      'isNew': false,
      'isUmbi': false,
      'status': '',
      'isDeleted': false,
      'gender': 'Female',
      'birthDate': '1975-10-19T00:00:00'
    },
    'creator': {
      'id': '503',
      'firstName': 'Farida',
      'lastName': 'Ghannouti'
    },
    'practitioner': {
      'id': 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      'photo': 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      'localizations': [
        {
          'lang': 'en',
          'name': 'Prof. Dr. Peter Verdonk'
        },
        {
          'lang': 'nl',
          'name': 'Prof. Dr. Peter Verdonk'
        }
      ],
      'specialties': [
        {
          'id': '629e7f91-18d8-4f1f-8567-259b6cf03cf6',
          'translations': {
            'en': 'Knee',
            'nl': 'Knie'
          }
        },
        {
          'id': 'cf611fec-ab40-4326-a845-6b1d18c9388b',
          'translations': {
            'nl': 'Sportletsels',
            'en': 'Sports injuries'
          }
        }
      ]
    },
    'appointmentType': 'Conscon',
    'note': '',
    'appointment': {
      'triggerInfo': {
        'succeeded': true,
        'triggers': [
          'patient_arrive'
        ]
      },
      'entity': {
        'id': 2127,
        'externalAppointmentId': '4433244',
        'type': 'AppointmentWorkflow',
        'state': 'consultation_booked',
        'additional': {
          'canCancel': false,
          'canReschedule': false
        }
      },
      'viewModel': {
        'id': 2127,
        'state': 'consultation_booked',
        'isOngoing': false
      }
    },
    'isFeedback': false
  },
  {
    'id': '4433245',
    'campus': {
      'id': '9',
      'name': 'Private Campus Kielse Vest',
      'address': 'Kielsevest 14, 2018 Antwerpen',
      'isAvailableQR': false
    },
    'dateTime': `${moment().format('YYYY-MM-DD')}T15:10:00Z`,
    'createdDateTime': `${moment().format('YYYY-MM-DD')}T10:30:02.433Z`,
    'patient': {
      'id': 'a806f92c-957b-4f49-9132-025ea42f49a5',
      'externalId': '731698',
      'firstName': 'Jozefien',
      'lastName': 'De Gheest',
      'isNew': true,
      'isUmbi': true,
      'status': 'Validated',
      'isDeleted': false,
      'gender': 'Female',
      'birthDate': '1986-02-24T00:00:00'
    },
    'creator': {
      'id': '503',
      'firstName': 'Farida',
      'lastName': 'Ghannouti'
    },
    'practitioner': {
      'id': 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      'photo': 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      'localizations': [
        {
          'lang': 'en',
          'name': 'Prof. Dr. Peter Verdonk'
        },
        {
          'lang': 'nl',
          'name': 'Prof. Dr. Peter Verdonk'
        }
      ],
      'specialties': [
        {
          'id': '629e7f91-18d8-4f1f-8567-259b6cf03cf6',
          'translations': {
            'en': 'Knee',
            'nl': 'Knie'
          }
        },
        {
          'id': 'cf611fec-ab40-4326-a845-6b1d18c9388b',
          'translations': {
            'nl': 'Sportletsels',
            'en': 'Sports injuries'
          }
        }
      ]
    },
    'appointmentType': 'Conscon',
    'note': '',
    'appointment': {
      'triggerInfo': {
        'succeeded': true,
        'triggers': [
          'patient_arrive'
        ]
      },
      'entity': {
        'id': 2129,
        'externalAppointmentId': '4433245',
        'type': 'AppointmentWorkflow',
        'state': 'consultation_booked',
        'additional': {
          'canCancel': false,
          'canReschedule': false
        }
      },
      'viewModel': {
        'id': 2129,
        'state': 'consultation_booked',
        'isOngoing': false
      }
    },
    'isFeedback': false
  },
  {
    'id': '4433247',
    'campus': {
      'id': '9',
      'name': 'Private Campus Kielse Vest',
      'address': 'Kielsevest 14, 2018 Antwerpen',
      'isAvailableQR': false
    },
    'dateTime': `${moment().format('YYYY-MM-DD')}T15:00:00Z`,
    'createdDateTime': `${moment().format('YYYY-MM-DD')}T10:30:52.44Z`,
    'patient': {
      'id': 'a806f92c-957b-4f49-9132-025ea42f49a5',
      'externalId': '731698',
      'firstName': 'Jozefien',
      'lastName': 'De Gheest',
      'isNew': true,
      'isUmbi': true,
      'status': 'Validated',
      'isDeleted': false,
      'gender': 'Female',
      'birthDate': '1986-02-24T00:00:00'
    },
    'creator': {
      'id': '503',
      'firstName': 'Farida',
      'lastName': 'Ghannouti'
    },
    'practitioner': {
      'id': 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      'photo': 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      'localizations': [
        {
          'lang': 'en',
          'name': 'Prof. Dr. Peter Verdonk'
        },
        {
          'lang': 'nl',
          'name': 'Prof. Dr. Peter Verdonk'
        }
      ],
      'specialties': [
        {
          'id': '629e7f91-18d8-4f1f-8567-259b6cf03cf6',
          'translations': {
            'en': 'Knee',
            'nl': 'Knie'
          }
        },
        {
          'id': 'cf611fec-ab40-4326-a845-6b1d18c9388b',
          'translations': {
            'nl': 'Sportletsels',
            'en': 'Sports injuries'
          }
        }
      ]
    },
    'appointmentType': 'Conscon',
    'note': '',
    'appointment': {
      'triggerInfo': {
        'succeeded': true,
        'triggers': [
          'patient_arrive'
        ]
      },
      'entity': {
        'id': 2131,
        'externalAppointmentId': '4433247',
        'type': 'AppointmentWorkflow',
        'state': 'consultation_booked',
        'additional': {
          'canCancel': false,
          'canReschedule': false
        }
      },
      'viewModel': {
        'id': 2131,
        'state': 'consultation_booked',
        'isOngoing': false
      }
    },
    'isFeedback': false
  },
  {
    'id': '4433248',
    'campus': {
      'id': '3',
      'name': 'Campus Antwerpen',
      'address': 'Harmoniestraat 68, 2018 Antwerpen',
      'isAvailableQR': false
    },
    'dateTime': `${moment().format('YYYY-MM-DD')}T16:00:00Z`,
    'createdDateTime': `${moment().format('YYYY-MM-DD')}T10:31:07.223Z`,
    'patient': {
      'id': 'f0a83e4b-f71f-44a1-bbb8-790912096089',
      'externalId': '759381',
      'firstName': 'fdfsdsdf',
      'lastName': 'asdfadsf',
      'isNew': true,
      'isUmbi': true,
      'status': 'Validated',
      'isDeleted': false,
      'gender': 'Female',
      'birthDate': '1968-08-26T00:00:00'
    },
    'creator': {
      'id': '503',
      'firstName': 'Farida',
      'lastName': 'Ghannouti'
    },
    'practitioner': {
      'id': 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      'photo': 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      'localizations': [
        {
          'lang': 'en',
          'name': 'Prof. Dr. Peter Verdonk'
        },
        {
          'lang': 'nl',
          'name': 'Prof. Dr. Peter Verdonk'
        }
      ],
      'specialties': [
        {
          'id': '629e7f91-18d8-4f1f-8567-259b6cf03cf6',
          'translations': {
            'en': 'Knee',
            'nl': 'Knie'
          }
        },
        {
          'id': 'cf611fec-ab40-4326-a845-6b1d18c9388b',
          'translations': {
            'nl': 'Sportletsels',
            'en': 'Sports injuries'
          }
        }
      ]
    },
    'appointmentType': 'Conscon',
    'note': '',
    'appointment': {
      'triggerInfo': {
        'succeeded': true,
        'triggers': [
          'patient_arrive'
        ]
      },
      'entity': {
        'id': 2133,
        'externalAppointmentId': '4433248',
        'type': 'AppointmentWorkflow',
        'state': 'consultation_booked',
        'additional': {
          'canCancel': false,
          'canReschedule': false
        }
      },
      'viewModel': {
        'id': 2133,
        'state': 'consultation_booked',
        'isOngoing': false
      }
    },
    'isFeedback': false
  },
  {
    'id': '4433249',
    'campus': {
      'id': '9',
      'name': 'Private Campus Kielse Vest',
      'address': 'Kielsevest 14, 2018 Antwerpen',
      'isAvailableQR': false
    },
    'dateTime': `${moment().format('YYYY-MM-DD')}T15:50:00Z`,
    'createdDateTime': `${moment().format('YYYY-MM-DD')}T10:31:22.813Z`,
    'patient': {
      'id': 'f0a83e4b-f71f-44a1-bbb8-790912096089',
      'externalId': '759381',
      'firstName': 'fdfsdsdf',
      'lastName': 'asdfadsf',
      'isNew': true,
      'isUmbi': true,
      'status': 'Validated',
      'isDeleted': false,
      'gender': 'Female',
      'birthDate': '1968-08-26T00:00:00'
    },
    'creator': {
      'id': '503',
      'firstName': 'Farida',
      'lastName': 'Ghannouti'
    },
    'practitioner': {
      'id': 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      'photo': 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      'localizations': [
        {
          'lang': 'en',
          'name': 'Prof. Dr. Peter Verdonk'
        },
        {
          'lang': 'nl',
          'name': 'Prof. Dr. Peter Verdonk'
        }
      ],
      'specialties': [
        {
          'id': '629e7f91-18d8-4f1f-8567-259b6cf03cf6',
          'translations': {
            'en': 'Knee',
            'nl': 'Knie'
          }
        },
        {
          'id': 'cf611fec-ab40-4326-a845-6b1d18c9388b',
          'translations': {
            'nl': 'Sportletsels',
            'en': 'Sports injuries'
          }
        }
      ]
    },
    'appointmentType': 'Conscon',
    'note': '',
    'appointment': {
      'triggerInfo': {
        'succeeded': true,
        'triggers': [
          'patient_arrive'
        ]
      },
      'entity': {
        'id': 2135,
        'externalAppointmentId': '4433249',
        'type': 'AppointmentWorkflow',
        'state': 'consultation_booked',
        'additional': {
          'canCancel': false,
          'canReschedule': false
        }
      },
      'viewModel': {
        'id': 2135,
        'state': 'consultation_booked',
        'isOngoing': false
      }
    },
    'isFeedback': false
  },
  {
    'id': '4433251',
    'campus': {
      'id': '9',
      'name': 'Private Campus Kielse Vest',
      'address': 'Kielsevest 14, 2018 Antwerpen',
      'isAvailableQR': false
    },
    'dateTime': `${moment().format('YYYY-MM-DD')}T15:40:00Z`,
    'createdDateTime': `${moment().format('YYYY-MM-DD')}T10:32:10.517Z`,
    'patient': {
      'externalId': '755621',
      'firstName': 'Andrey98',
      'lastName': 'Patseyko2',
      'isNew': true,
      'isUmbi': false,
      'status': '',
      'isDeleted': false,
      'gender': 'Male',
      'birthDate': '1981-05-03T00:00:00'
    },
    'creator': {
      'id': '503',
      'firstName': 'Farida',
      'lastName': 'Ghannouti'
    },
    'practitioner': {
      'id': 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      'photo': 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      'localizations': [
        {
          'lang': 'en',
          'name': 'Prof. Dr. Peter Verdonk'
        },
        {
          'lang': 'nl',
          'name': 'Prof. Dr. Peter Verdonk'
        }
      ],
      'specialties': [
        {
          'id': '629e7f91-18d8-4f1f-8567-259b6cf03cf6',
          'translations': {
            'en': 'Knee',
            'nl': 'Knie'
          }
        },
        {
          'id': 'cf611fec-ab40-4326-a845-6b1d18c9388b',
          'translations': {
            'nl': 'Sportletsels',
            'en': 'Sports injuries'
          }
        }
      ]
    },
    'appointmentType': 'Conscon',
    'note': '',
    'appointment': {
      'triggerInfo': {
        'succeeded': true,
        'triggers': [
          'patient_arrive'
        ]
      },
      'entity': {
        'id': 2137,
        'externalAppointmentId': '4433251',
        'type': 'AppointmentWorkflow',
        'state': 'consultation_booked',
        'additional': {
          'canCancel': false,
          'canReschedule': false
        }
      },
      'viewModel': {
        'id': 2137,
        'state': 'consultation_booked',
        'isOngoing': false
      }
    },
    'isFeedback': false
  }
];

//──── testAppointmentsReit ──────────────────────────────────────────────────────────────

export const testAppointments = {
  // verdonk
  'd17b0987-9445-4ba9-bcc8-59ad4876e6c3': [
    {
      id: '4430736',
      campus: {
        id: '5',
        name: 'Campus Deurne',
        address: 'Stevenslei 20, 2100 Deurne'
      },
      dateTime: '2018-11-23T13:50:00',
      createdDateTime: '2018-11-22T07:01:56.47',
      patient: {
        externalId: '444673',
        firstName: 'Dave',
        lastName: 'Heirman',
        isNew: false,
        isUmbi: false,
        status: '',
        isDeleted: false,
        gender: 'Male',
        birthDate: '1976-12-11T00:00:00'
      },
      creator: {
        id: '503',
        firstName: 'Farida',
        lastName: 'Ghannouti'
      },
      practitioner: {
        id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
        photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
        localizations: [
          {
            lang: 'en',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knee and sports injuries'
          },
          {
            lang: 'nl',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knie en sportletsels'
          }
        ]
      },
      appointmentType: 'Conscon',
      status: 'InProgress',
      isFeedback: false
    },
    {
      id: '4430737',
      campus: {
        id: '5',
        name: 'Campus Deurne',
        address: 'Stevenslei 20, 2100 Deurne'
      },
      dateTime: '2018-11-23T14:30:00',
      createdDateTime: '2018-11-22T07:02:14.197',
      patient: {
        id: 'db4d241d-aed4-481a-ab32-5657a0372a96',
        externalId: '37783',
        firstName: 'Dennis Jozef',
        lastName: 'Heirman',
        isNew: false,
        isUmbi: true,
        status: 'Validated',
        isDeleted: false,
        gender: 'Male',
        birthDate: '1983-05-18T00:00:00'
      },
      creator: {
        id: '503',
        firstName: 'Farida',
        lastName: 'Ghannouti'
      },
      practitioner: {
        id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
        photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
        localizations: [
          {
            lang: 'en',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knee and sports injuries'
          },
          {
            lang: 'nl',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knie en sportletsels'
          }
        ]
      },
      appointmentType: 'Conscon',
      status: 'Booked',
      isFeedback: false
    },
    {
      id: '4430738',
      campus: {
        id: '5',
        name: 'Campus Deurne',
        address: 'Stevenslei 20, 2100 Deurne'
      },
      dateTime: '2018-11-23T15:00:00',
      createdDateTime: '2018-11-22T07:02:30.48',
      patient: {
        id: 'db4d241d-aed4-481a-ab32-5657a0372a96',
        externalId: '37783',
        firstName: 'Dennis Jozef',
        lastName: 'Heirman',
        isNew: false,
        isUmbi: true,
        status: 'Validated',
        isDeleted: false,
        gender: 'Male',
        birthDate: '1983-05-18T00:00:00'
      },
      creator: {
        id: '503',
        firstName: 'Farida',
        lastName: 'Ghannouti'
      },
      practitioner: {
        id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
        photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
        localizations: [
          {
            lang: 'en',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knee and sports injuries'
          },
          {
            lang: 'nl',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knie en sportletsels'
          }
        ]
      },
      appointmentType: 'Conscon',
      status: 'Booked',
      isFeedback: false
    },
    {
      id: '4430740',
      campus: {
        id: '5',
        name: 'Campus Deurne',
        address: 'Stevenslei 20, 2100 Deurne'
      },
      dateTime: '2018-11-23T14:00:00',
      createdDateTime: '2018-11-22T07:03:14.217',
      invoice: {
        id: '08d6510e-11d3-b09d-22c1-bca9123edf28',
        status: 'Open',
        rowVersion: 3
      },
      patient: {
        id: 'db4d241d-aed4-481a-ab32-5657a0372a96',
        externalId: '37783',
        firstName: 'Dennis Jozef',
        lastName: 'Heirman',
        isNew: false,
        isUmbi: true,
        status: 'Validated',
        isDeleted: false,
        gender: 'Male',
        birthDate: '1983-05-18T00:00:00'
      },
      creator: {
        id: '503',
        firstName: 'Farida',
        lastName: 'Ghannouti'
      },
      practitioner: {
        id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
        photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
        localizations: [
          {
            lang: 'en',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knee and sports injuries'
          },
          {
            lang: 'nl',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knie en sportletsels'
          }
        ]
      },
      appointmentType: 'Conscon',
      status: 'Finished',
      isFeedback: false
    },
    {
      id: '4430741',
      campus: {
        id: '5',
        name: 'Campus Deurne',
        address: 'Stevenslei 20, 2100 Deurne'
      },
      dateTime: '2018-11-23T14:00:00',
      createdDateTime: '2018-11-22T07:05:51.617',
      patient: {
        id: 'db4d241d-aed4-481a-ab32-5657a0372a96',
        externalId: '37783',
        firstName: 'Dennis Jozef',
        lastName: 'Heirman',
        isNew: false,
        isUmbi: true,
        status: 'Validated',
        isDeleted: false,
        gender: 'Male',
        birthDate: '1983-05-18T00:00:00'
      },
      creator: {
        id: '503',
        firstName: 'Farida',
        lastName: 'Ghannouti'
      },
      practitioner: {
        id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
        photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
        localizations: [
          {
            lang: 'en',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knee and sports injuries'
          },
          {
            lang: 'nl',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knie en sportletsels'
          }
        ]
      },
      appointmentType: 'Conscon',
      status: 'InProgress',
      isFeedback: false
    },
    {
      id: '4430742',
      campus: {
        id: '5',
        name: 'Campus Deurne',
        address: 'Stevenslei 20, 2100 Deurne'
      },
      dateTime: '2018-11-23T14:10:00',
      createdDateTime: '2018-11-22T07:06:13.64',
      patient: {
        id: 'db4d241d-aed4-481a-ab32-5657a0372a96',
        externalId: '37783',
        firstName: 'Dennis Jozef',
        lastName: 'Heirman',
        isNew: false,
        isUmbi: true,
        status: 'Validated',
        isDeleted: false,
        gender: 'Male',
        birthDate: '1983-05-18T00:00:00'
      },
      creator: {
        id: '503',
        firstName: 'Farida',
        lastName: 'Ghannouti'
      },
      practitioner: {
        id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
        photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
        localizations: [
          {
            lang: 'en',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knee and sports injuries'
          },
          {
            lang: 'nl',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knie en sportletsels'
          }
        ]
      },
      appointmentType: 'Conscon',
      status: 'InProgress',
      isFeedback: false
    },
    {
      id: '4430743',
      campus: {
        id: '5',
        name: 'Campus Deurne',
        address: 'Stevenslei 20, 2100 Deurne'
      },
      dateTime: '2018-11-23T16:00:00',
      createdDateTime: '2018-11-22T07:06:38.933',
      patient: {
        id: 'db4d241d-aed4-481a-ab32-5657a0372a96',
        externalId: '37783',
        firstName: 'Dennis Jozef',
        lastName: 'Heirman',
        isNew: false,
        isUmbi: true,
        status: 'Validated',
        isDeleted: false,
        gender: 'Male',
        birthDate: '1983-05-18T00:00:00'
      },
      creator: {
        id: '503',
        firstName: 'Farida',
        lastName: 'Ghannouti'
      },
      practitioner: {
        id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
        photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
        localizations: [
          {
            lang: 'en',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knee and sports injuries'
          },
          {
            lang: 'nl',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knie en sportletsels'
          }
        ]
      },
      appointmentType: 'Conscon',
      status: 'Booked',
      isFeedback: false
    },
    {
      id: '4430744',
      campus: {
        id: '5',
        name: 'Campus Deurne',
        address: 'Stevenslei 20, 2100 Deurne'
      },
      dateTime: '2018-11-23T16:00:00',
      createdDateTime: '2018-11-22T07:06:57.17',
      patient: {
        id: 'db4d241d-aed4-481a-ab32-5657a0372a96',
        externalId: '37783',
        firstName: 'Dennis Jozef',
        lastName: 'Heirman',
        isNew: false,
        isUmbi: true,
        status: 'Validated',
        isDeleted: false,
        gender: 'Male',
        birthDate: '1983-05-18T00:00:00'
      },
      creator: {
        id: '503',
        firstName: 'Farida',
        lastName: 'Ghannouti'
      },
      practitioner: {
        id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
        photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
        localizations: [
          {
            lang: 'en',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knee and sports injuries'
          },
          {
            lang: 'nl',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knie en sportletsels'
          }
        ]
      },
      appointmentType: 'Conscon',
      status: 'Booked',
      isFeedback: false
    },
    {
      id: '4430746',
      campus: {
        id: '5',
        name: 'Campus Deurne',
        address: 'Stevenslei 20, 2100 Deurne'
      },
      dateTime: '2018-11-23T15:30:00',
      createdDateTime: '2018-11-22T07:08:21.09',
      patient: {
        externalId: '152859',
        firstName: 'Dario',
        lastName: 'Cagnazzo',
        isNew: false,
        isUmbi: false,
        status: '',
        isDeleted: false,
        gender: 'Male',
        birthDate: '1983-05-18T00:00:00'
      },
      creator: {
        id: '503',
        firstName: 'Farida',
        lastName: 'Ghannouti'
      },
      practitioner: {
        id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
        photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
        localizations: [
          {
            lang: 'en',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knee and sports injuries'
          },
          {
            lang: 'nl',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knie en sportletsels'
          }
        ]
      },
      appointmentType: 'Conscon',
      status: 'Booked',
      isFeedback: false
    },
    {
      id: '4430749',
      campus: {
        id: '5',
        name: 'Campus Deurne',
        address: 'Stevenslei 20, 2100 Deurne'
      },
      dateTime: '2018-11-23T16:40:00',
      createdDateTime: '2018-11-22T07:09:11.867',
      patient: {
        externalId: '152859',
        firstName: 'Dario',
        lastName: 'Cagnazzo',
        isNew: false,
        isUmbi: false,
        status: '',
        isDeleted: false,
        gender: 'Male',
        birthDate: '1983-05-18T00:00:00'
      },
      creator: {
        id: '503',
        firstName: 'Farida',
        lastName: 'Ghannouti'
      },
      practitioner: {
        id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
        photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
        localizations: [
          {
            lang: 'en',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knee and sports injuries'
          },
          {
            lang: 'nl',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knie en sportletsels'
          }
        ]
      },
      appointmentType: 'Conscon',
      status: 'Booked',
      isFeedback: false
    },
    {
      id: '4430751',
      campus: {
        id: '5',
        name: 'Campus Deurne',
        address: 'Stevenslei 20, 2100 Deurne'
      },
      dateTime: '2018-11-23T16:30:00',
      createdDateTime: '2018-11-22T07:09:44.867',
      patient: {
        externalId: '355920',
        firstName: 'Youssef',
        lastName: 'Temsamani Rais',
        isNew: false,
        isUmbi: false,
        status: '',
        isDeleted: false,
        gender: 'Male',
        birthDate: '1983-05-18T00:00:00'
      },
      creator: {
        id: '503',
        firstName: 'Farida',
        lastName: 'Ghannouti'
      },
      practitioner: {
        id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
        photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
        localizations: [
          {
            lang: 'en',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knee and sports injuries'
          },
          {
            lang: 'nl',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knie en sportletsels'
          }
        ]
      },
      appointmentType: 'Conscon',
      status: 'Booked',
      isFeedback: false
    },
    {
      id: '4430752',
      campus: {
        id: '5',
        name: 'Campus Deurne',
        address: 'Stevenslei 20, 2100 Deurne'
      },
      dateTime: '2018-11-23T16:50:00',
      createdDateTime: '2018-11-22T07:10:01.24',
      patient: {
        externalId: '355920',
        firstName: 'Youssef',
        lastName: 'Temsamani Rais',
        isNew: false,
        isUmbi: false,
        status: '',
        isDeleted: false,
        gender: 'Male',
        birthDate: '1983-05-18T00:00:00'
      },
      creator: {
        id: '503',
        firstName: 'Farida',
        lastName: 'Ghannouti'
      },
      practitioner: {
        id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
        photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
        localizations: [
          {
            lang: 'en',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knee and sports injuries'
          },
          {
            lang: 'nl',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knie en sportletsels'
          }
        ]
      },
      appointmentType: 'Conscon',
      status: 'Booked',
      isFeedback: false
    },
    {
      id: '4430753',
      campus: {
        id: '5',
        name: 'Campus Deurne',
        address: 'Stevenslei 20, 2100 Deurne'
      },
      dateTime: '2018-11-23T15:10:00',
      createdDateTime: '2018-11-22T07:10:19.88',
      patient: {
        externalId: '355920',
        firstName: 'Youssef',
        lastName: 'Temsamani Rais',
        isNew: false,
        isUmbi: false,
        status: '',
        isDeleted: false,
        gender: 'Male',
        birthDate: '1983-05-18T00:00:00'
      },
      creator: {
        id: '503',
        firstName: 'Farida',
        lastName: 'Ghannouti'
      },
      practitioner: {
        id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
        photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
        localizations: [
          {
            lang: 'en',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knee and sports injuries'
          },
          {
            lang: 'nl',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knie en sportletsels'
          }
        ]
      },
      appointmentType: 'Conscon',
      status: 'Booked',
      isFeedback: false
    },
    {
      id: '4430754',
      campus: {
        id: '5',
        name: 'Campus Deurne',
        address: 'Stevenslei 20, 2100 Deurne'
      },
      dateTime: '2018-11-23T15:40:00',
      createdDateTime: '2018-11-22T07:10:34.43',
      patient: {
        externalId: '355920',
        firstName: 'Youssef',
        lastName: 'Temsamani Rais',
        isNew: false,
        isUmbi: false,
        status: '',
        isDeleted: false,
        gender: 'Male',
        birthDate: '1983-05-18T00:00:00'
      },
      creator: {
        id: '503',
        firstName: 'Farida',
        lastName: 'Ghannouti'
      },
      practitioner: {
        id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
        photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
        localizations: [
          {
            lang: 'en',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knee and sports injuries'
          },
          {
            lang: 'nl',
            name: 'Prof. Dr. Peter Verdonk',
            specialties: 'Knie en sportletsels'
          }
        ]
      },
      appointmentType: 'Conscon',
      status: 'Booked',
      isFeedback: false
    }
  ],
  // reit
  'ddda7b4d-b30c-4d6b-84be-63676935085b': [
    {
      id: '4430739',
      campus: {
        id: '5',
        name: 'Campus Deurne',
        address: 'Stevenslei 20, 2100 Deurne'
      },
      dateTime: '2018-11-23T14:00:00',
      createdDateTime: '2018-11-22T07:02:53.193',
      invoice: {
        id: '08d65122-58fa-5d4b-7055-bb8a3bdea924',
        status: 'Open',
        rowVersion: 5
      },
      patient: {
        id: 'db4d241d-aed4-481a-ab32-5657a0372a96',
        externalId: '37783',
        firstName: 'Dennis Jozef',
        lastName: 'Heirman',
        isNew: false,
        isUmbi: true,
        status: 'Validated',
        isDeleted: false,
        gender: 'Male',
        birthDate: '1983-05-18T00:00:00'
      },
      creator: {
        id: '503',
        firstName: 'Farida',
        lastName: 'Ghannouti'
      },
      practitioner: {
        id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
        photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
        localizations: [
          {
            lang: 'en',
            name: 'Prof. Dr. Roger Van Riet',
            specialties: 'Elbow, wrist and hand'
          },
          {
            lang: 'nl',
            name: 'Prof. Dr. Roger Van Riet',
            specialties: 'Elleboog, pols en hand'
          }
        ]
      },
      appointmentType: 'Conscon',
      status: 'Finished',
      isFeedback: false
    },
    {
      id: '4430745',
      campus: {
        id: '5',
        name: 'Campus Deurne',
        address: 'Stevenslei 20, 2100 Deurne'
      },
      dateTime: '2018-11-23T16:00:00',
      createdDateTime: '2018-11-22T07:07:19.34',
      invoice: {
        id: '08d65147-48f1-6847-eeb5-827d38526b8e',
        status: 'Open',
        rowVersion: 4
      },
      patient: {
        id: 'db4d241d-aed4-481a-ab32-5657a0372a96',
        externalId: '37783',
        firstName: 'Dennis Jozef',
        lastName: 'Heirman',
        isNew: false,
        isUmbi: true,
        status: 'Validated',
        isDeleted: false,
        gender: 'Male',
        birthDate: '1983-05-18T00:00:00'
      },
      creator: {
        id: '503',
        firstName: 'Farida',
        lastName: 'Ghannouti'
      },
      practitioner: {
        id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
        photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
        localizations: [
          {
            lang: 'en',
            name: 'Prof. Dr. Roger Van Riet',
            specialties: 'Elbow, wrist and hand'
          },
          {
            lang: 'nl',
            name: 'Prof. Dr. Roger Van Riet',
            specialties: 'Elleboog, pols en hand'
          }
        ]
      },
      appointmentType: 'Conscon',
      status: 'Finished',
      isFeedback: false
    },
    {
      id: '4430747',
      campus: {
        id: '5',
        name: 'Campus Deurne',
        address: 'Stevenslei 20, 2100 Deurne'
      },
      dateTime: '2018-11-23T16:30:00',
      createdDateTime: '2018-11-22T07:08:38.23',
      patient: {
        externalId: '152859',
        firstName: 'Dario',
        lastName: 'Cagnazzo',
        isNew: false,
        isUmbi: false,
        status: '',
        isDeleted: false,
        gender: 'Male',
        birthDate: '1983-05-18T00:00:00'
      },
      creator: {
        id: '503',
        firstName: 'Farida',
        lastName: 'Ghannouti'
      },
      practitioner: {
        id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
        photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
        localizations: [
          {
            lang: 'en',
            name: 'Prof. Dr. Roger Van Riet',
            specialties: 'Elbow, wrist and hand'
          },
          {
            lang: 'nl',
            name: 'Prof. Dr. Roger Van Riet',
            specialties: 'Elleboog, pols en hand'
          }
        ]
      },
      appointmentType: 'Conscon',
      status: 'Booked',
      isFeedback: false
    },
    {
      id: '4430748',
      campus: {
        id: '5',
        name: 'Campus Deurne',
        address: 'Stevenslei 20, 2100 Deurne'
      },
      dateTime: '2018-11-23T15:20:00',
      createdDateTime: '2018-11-22T07:08:53.22',
      invoice: {
        id: '08d65130-932b-1290-9233-176f54c664bb',
        status: 'Open',
        rowVersion: 0
      },
      patient: {
        externalId: '152859',
        firstName: 'Dario',
        lastName: 'Cagnazzo',
        isNew: false,
        isUmbi: false,
        status: '',
        isDeleted: false,
        gender: 'Male',
        birthDate: '1983-05-18T00:00:00'
      },
      creator: {
        id: '503',
        firstName: 'Farida',
        lastName: 'Ghannouti'
      },
      practitioner: {
        id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
        photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
        localizations: [
          {
            lang: 'en',
            name: 'Prof. Dr. Roger Van Riet',
            specialties: 'Elbow, wrist and hand'
          },
          {
            lang: 'nl',
            name: 'Prof. Dr. Roger Van Riet',
            specialties: 'Elleboog, pols en hand'
          }
        ]
      },
      appointmentType: 'Conscon',
      status: 'Finished',
      isFeedback: false
    },
    {
      id: '4430750',
      campus: {
        id: '5',
        name: 'Campus Deurne',
        address: 'Stevenslei 20, 2100 Deurne'
      },
      dateTime: '2018-11-23T16:50:00',
      createdDateTime: '2018-11-22T07:09:28.347',
      patient: {
        externalId: '355920',
        firstName: 'Youssef',
        lastName: 'Temsamani Rais',
        isNew: false,
        isUmbi: false,
        status: '',
        isDeleted: false,
        gender: 'Male',
        birthDate: '1983-05-18T00:00:00'
      },
      creator: {
        id: '503',
        firstName: 'Farida',
        lastName: 'Ghannouti'
      },
      practitioner: {
        id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
        photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
        localizations: [
          {
            lang: 'en',
            name: 'Prof. Dr. Roger Van Riet',
            specialties: 'Elbow, wrist and hand'
          },
          {
            lang: 'nl',
            name: 'Prof. Dr. Roger Van Riet',
            specialties: 'Elleboog, pols en hand'
          }
        ]
      },
      appointmentType: 'Conscon',
      status: 'Booked',
      isFeedback: false
    }
  ]
};

//──── testPractitionersList ─────────────────────────────────────────────────────────────

export const testPractitionersList = [
  {
    'id': 'abd0721d-758d-11ea-9552-0242ac140013',
    'isActive': true,
    'onlineBookingActive': true,
    'photo': 'https://www.zmack.be/media/doctor/photo/zmack-1-11.jpg',
    'externalIds': [
      '114'
    ],
    'email': 'nacer.nadjmi@azmonica.be',
    'phone': '',
    'title': 'Prof. Dr.',
    'firstName': 'Nacer',
    'lastName': 'Nadjmi',
    'paymentService': '',
    'localizations': [
      {
        'lang': 'en',
        'name': 'Prof. Dr. Nacer Nadjmi'
      },
      {
        'lang': 'nl',
        'name': 'Prof. Dr. Nacer Nadjmi'
      }
    ],
    'specialties': [

    ],
    'appointmentTypes': [
      {
        'name': 'new',
        'value': 288
      },
      {
        'name': 'follow_up',
        'value': 285
      }
    ]
  },
  {
    'id': 'c6bea5e1-830d-4971-93ae-5dda33247416',
    'isActive': true,
    'onlineBookingActive': false,
    'photo': 'https://orthoca.be/wp-content/uploads/2014/07/jaspars-540x580-540x580.png',
    'externalIds': [
      '227',
      '229'
    ],
    'email': 'olivier.verborgt@azmonica.be',
    'phone': '03 88888888',
    'title': 'Prof. Dr.',
    'firstName': 'Olivier',
    'lastName': 'Verborgt',
    'paymentService': 'SL-4882-5171',
    'localizations': [
      {
        'lang': 'en',
        'name': 'Prof. Dr. Olivier Verborgt'
      },
      {
        'lang': 'nl',
        'name': 'Prof. Dr. Olivier Verborgt'
      }
    ],
    'specialties': [
      {
        'id': '053136f0-38fc-47ea-9feb-58c336510217',
        'translations': {
          'en': 'Shoulder',
          'nl': 'Schouder'
        }
      }
    ],
    'appointmentTypes': [
      {
        'name': 'new',
        'value': 288
      },
      {
        'name': 'follow_up',
        'value': 549
      }
    ]
  },
  {
    'id': 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
    'isActive': true,
    'onlineBookingActive': true,
    'photo': 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
    'externalIds': [
      '272'
    ],
    'email': 'peter.verdonk@azmonica.be',
    'phone': '03 99999999',
    'title': 'Prof. Dr.',
    'firstName': 'Peter',
    'lastName': 'Verdonk',
    'paymentService': 'SL-4882-5171',
    'localizations': [
      {
        'lang': 'en',
        'name': 'Prof. Dr. Peter Verdonk'
      },
      {
        'lang': 'nl',
        'name': 'Prof. Dr. Peter Verdonk'
      }
    ],
    'specialties': [
      {
        'id': '629e7f91-18d8-4f1f-8567-259b6cf03cf6',
        'translations': {
          'en': 'Knee',
          'nl': 'Knie'
        }
      },
      {
        'id': 'cf611fec-ab40-4326-a845-6b1d18c9388b',
        'translations': {
          'nl': 'Sportletsels',
          'en': 'Sports injuries'
        }
      }
    ],
    'appointmentTypes': [
      {
        'name': 'new',
        'value': 288
      },
      {
        'name': 'follow_up',
        'value': 285
      }
    ]
  },
  {
    'id': 'ddda7b4d-b30c-4d6b-84be-63676935085b',
    'isActive': false,
    'onlineBookingActive': true,
    'photo': 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
    'externalIds': [
      '152',
      '159'
    ],
    'email': 'roger.vanriet@azmonica.be',
    'phone': '+320455555555',
    'title': 'Prof. Dr.',
    'firstName': 'Roger',
    'lastName': 'Van Riet',
    'paymentService': 'SL-4882-5171',
    'localizations': [
      {
        'lang': 'en',
        'name': 'Prof. Dr. Roger Van Riet'
      },
      {
        'lang': 'nl',
        'name': 'Prof. Dr. Roger Van Riet'
      }
    ],
    'specialties': [
      {
        'id': '3bc8d1fb-13a4-45ff-a998-d6199876359d',
        'translations': {
          'en': 'Hand & Wrist',
          'nl': 'Hand & Pols'
        }
      },
      {
        'id': 'f9ccb736-2420-4110-b302-a516ee7675d6',
        'translations': {
          'en': 'Elbow',
          'nl': 'Elleboog'
        }
      }
    ],
    'appointmentTypes': [
      {
        'name': 'new',
        'value': 288
      },
      {
        'name': 'follow_up',
        'value': 285
      }
    ]
  }
];

//──── invoiceList ───────────────────────────────────────────────────────────────────

export const invoiceServicesList = {
  // verdonk
  'd17b0987-9445-4ba9-bcc8-59ad4876e6c3': [
    {
      id: '12b4eb0e-6f0a-482a-b312-a53d6ecdbd27',
      defaultCampusId: [],
      name: 'Injectie Adant One',
      nomenclature: '',
      price: 1.2,
      category: {
        id: '41ae7ec5-317a-44a0-9ee6-893b99e8b884',
        order: 3,
        name: 'Injecties'
      }
    },
    {
      id: '220d29ca-dc2f-4d76-bc6b-f3bf9fa8e3aa',
      defaultCampusId: [],
      name: 'Injectie Ostenil',
      nomenclature: '',
      price: 0.4,
      category: {
        id: '41ae7ec5-317a-44a0-9ee6-893b99e8b884',
        order: 3,
        name: 'Injecties'
      }
    },
    {
      id: '4be52361-571c-464e-8f8d-166554277870',
      defaultCampusId: [],
      name: 'Injectie PRGF',
      nomenclature: '',
      price: 2.5,
      category: {
        id: '41ae7ec5-317a-44a0-9ee6-893b99e8b884',
        order: 3,
        name: 'Injecties'
      }
    },
    {
      id: '67d8b166-d3f5-41d9-aedf-2d4119d69bc6',
      defaultCampusId: [],
      name: 'Injectie Depo',
      nomenclature: '',
      price: 0.1,
      category: {
        id: '41ae7ec5-317a-44a0-9ee6-893b99e8b884',
        order: 3,
        name: 'Injecties'
      }
    },
    {
      id: 'bf11a6f6-3795-40b5-9849-a625087a07d5',
      defaultCampusId: [],
      name: 'Injectie Ostenil plus',
      nomenclature: '',
      price: 0.8,
      category: {
        id: '41ae7ec5-317a-44a0-9ee6-893b99e8b884',
        order: 3,
        name: 'Injecties'
      }
    },
    {
      id: '3e4fc978-c414-4af9-9ef8-ee0d1b094bca',
      defaultCampusId: [],
      name: 'Fractuur tibiaplateau',
      nomenclature: '298830',
      price: 0.84,
      category: {
        id: 'a48cc6cb-fe40-4cd6-bca7-bfbfd592e569',
        order: 4,
        name: 'Fracturen'
      }
    },
    {
      id: 'c6a1469d-e185-4a54-962a-3896d94349b2',
      defaultCampusId: [],
      name: 'Patellafractuur',
      nomenclature: '298815',
      price: 0.84,
      category: {
        id: 'a48cc6cb-fe40-4cd6-bca7-bfbfd592e569',
        order: 4,
        name: 'Fracturen'
      }
    },
    {
      id: 'eb4b26ee-1a8f-431c-97e0-1ace8f33154a',
      defaultCampusId: [],
      name: 'Fractuur femurcondyl',
      nomenclature: '298793',
      price: 1.21,
      category: {
        id: 'a48cc6cb-fe40-4cd6-bca7-bfbfd592e569',
        order: 4,
        name: 'Fracturen'
      }
    },
    {
      id: '446b2dc1-a02c-42fd-bf6e-814d1e1a13a4',
      defaultCampusId: [],
      name: 'Consultatie 50 euro',
      nomenclature: '102012',
      price: 0.5,
      category: {
        id: 'fbae34df-83e2-4344-9670-e1b470cd9334',
        order: 1,
        name: 'Standaard'
      }
    },
    {
      id: '62fa490d-3376-44c8-b973-c830521de880',
      defaultCampusId: ['3'],
      name: 'Consultatie 55 euro (Antw)',
      nomenclature: '102012',
      price: 0.55,
      category: {
        id: 'fbae34df-83e2-4344-9670-e1b470cd9334',
        order: 1,
        name: 'Standaard'
      }
    },
    {
      id: '6d496b0d-ae8b-412f-8d7c-efc36ed1bb3b',
      defaultCampusId: [],
      name: 'Consultatie 80 euro',
      nomenclature: '102012',
      price: 0.8,
      category: {
        id: 'fbae34df-83e2-4344-9670-e1b470cd9334',
        order: 1,
        name: 'Standaard'
      }
    },
    {
      id: '85ae426a-6a81-495e-8c3c-284ea041be83',
      defaultCampusId: [],
      name: 'Verslag',
      nomenclature: '102012',
      price: 0.07,
      category: {
        id: 'fbae34df-83e2-4344-9670-e1b470cd9334',
        order: 1,
        name: 'Standaard'
      }
    },
    {
      id: 'b7f85ff7-ebff-4618-b887-04319d950026',
      defaultCampusId: ['5'],
      name: 'Consultatie 45 euro (Deurne)',
      nomenclature: '102012',
      price: 0.45,
      category: {
        id: 'fbae34df-83e2-4344-9670-e1b470cd9334',
        order: 1,
        name: 'Standaard'
      }
    },
    {
      id: 'e6eabd7f-cfdc-4e5e-936d-6790e4205954',
      defaultCampusId: ['9'],
      name: 'Consultatie 70 euro (Kielse)',
      nomenclature: '102012',
      price: 0.7,
      category: {
        id: 'fbae34df-83e2-4344-9670-e1b470cd9334',
        order: 1,
        name: 'Standaard'
      }
    }
  ],
  // reit
  'ddda7b4d-b30c-4d6b-84be-63676935085b': [
    {
      id: '85e5ce71-b68b-44d5-b41d-ae844146929a',
      defaultCampusId: [],
      name: 'Injectie Adant One',
      nomenclature: '',
      price: 1.2,
      category: {
        id: '41ae7ec5-317a-44a0-9ee6-893b99e8b884',
        order: 3,
        name: 'Injecties'
      }
    },
    {
      id: 'a1ffcf40-8cd2-47d8-96b7-1d44194d9cc1',
      defaultCampusId: [],
      name: 'Injectie Depo',
      nomenclature: '',
      price: 0.1,
      category: {
        id: '41ae7ec5-317a-44a0-9ee6-893b99e8b884',
        order: 3,
        name: 'Injecties'
      }
    },
    {
      id: 'b5edfea4-0e17-4656-8a69-475fd469f65f',
      defaultCampusId: [],
      name: 'Injectie Adant One',
      nomenclature: '',
      price: 2.5,
      category: {
        id: '41ae7ec5-317a-44a0-9ee6-893b99e8b884',
        order: 3,
        name: 'Injecties'
      }
    },
    {
      id: 'd140de20-3f0d-4935-babd-127a92c4baff',
      defaultCampusId: [],
      name: 'Injectie Ostenil',
      nomenclature: '',
      price: 0.4,
      category: {
        id: '41ae7ec5-317a-44a0-9ee6-893b99e8b884',
        order: 3,
        name: 'Injecties'
      }
    },
    {
      id: 'e88ca962-b7f9-4df4-bcca-19b26ea46d96',
      defaultCampusId: [],
      name: 'Injectie Ostenil plus',
      nomenclature: '',
      price: 0.8,
      category: {
        id: '41ae7ec5-317a-44a0-9ee6-893b99e8b884',
        order: 3,
        name: 'Injecties'
      }
    },
    {
      id: '11ab76ba-8291-4b43-8f04-87670561c30f',
      defaultCampusId: [],
      name: 'Repositie fractuur 1 vinger',
      nomenclature: '296435',
      price: 0.7,
      category: {
        id: 'a48cc6cb-fe40-4cd6-bca7-bfbfd592e569',
        order: 4,
        name: 'Fracturen'
      }
    },
    {
      id: '22c0a10a-99c6-4232-9edb-e67e2a615666',
      defaultCampusId: [],
      name: 'Fractuur handwortel',
      nomenclature: '296671',
      price: 0.61,
      category: {
        id: 'a48cc6cb-fe40-4cd6-bca7-bfbfd592e569',
        order: 4,
        name: 'Fracturen'
      }
    },
    {
      id: '24ab217b-e6a0-4221-afaf-b745e9db564d',
      defaultCampusId: [],
      name: 'Fractuur meer vingers',
      nomenclature: '296995',
      price: 0.37,
      category: {
        id: 'a48cc6cb-fe40-4cd6-bca7-bfbfd592e569',
        order: 4,
        name: 'Fracturen'
      }
    },
    {
      id: '4724b16b-b81c-4d97-a15e-bc77054a82f4',
      defaultCampusId: [],
      name: 'Humeruspalet',
      nomenclature: '296855',
      price: 0.74,
      category: {
        id: 'a48cc6cb-fe40-4cd6-bca7-bfbfd592e569',
        order: 4,
        name: 'Fracturen'
      }
    },
    {
      id: '65f9c9db-99de-43b1-bc38-d6ee9ed7c8c2',
      defaultCampusId: [],
      name: 'Fractuur distale radius',
      nomenclature: '296936',
      price: 0.61,
      category: {
        id: 'a48cc6cb-fe40-4cd6-bca7-bfbfd592e569',
        order: 4,
        name: 'Fracturen'
      }
    },
    {
      id: '8cc6e4ed-ff10-40ec-80a8-34cba2f0d820',
      defaultCampusId: [],
      name: 'Humerusdiafyse',
      nomenclature: '296833',
      price: 0.93,
      category: {
        id: 'a48cc6cb-fe40-4cd6-bca7-bfbfd592e569',
        order: 4,
        name: 'Fracturen'
      }
    },
    {
      id: '9e93eb95-5ec6-485c-8df0-f661f7ad67b3',
      defaultCampusId: [],
      name: 'Onderarmdiafyse',
      nomenclature: '296914',
      price: 0.74,
      category: {
        id: 'a48cc6cb-fe40-4cd6-bca7-bfbfd592e569',
        order: 4,
        name: 'Fracturen'
      }
    },
    {
      id: 'a7ca8c16-282f-4bfb-ab36-11bb99a49c47',
      defaultCampusId: [],
      name: 'Fractuur 1 vinger',
      nomenclature: '296973',
      price: 0.28,
      category: {
        id: 'a48cc6cb-fe40-4cd6-bca7-bfbfd592e569',
        order: 4,
        name: 'Fracturen'
      }
    },
    {
      id: 'b108f7cd-2551-4375-9159-272759af0233',
      defaultCampusId: [],
      name: 'Fractuur radiuskop/hals',
      nomenclature: '296892',
      price: 0.74,
      category: {
        id: 'a48cc6cb-fe40-4cd6-bca7-bfbfd592e569',
        order: 4,
        name: 'Fracturen'
      }
    },
    {
      id: 'be758f98-b777-4fd9-aba8-a9b8f9ad0ebc',
      defaultCampusId: [],
      name: 'Fractuur middelhand',
      nomenclature: '296951',
      price: 0.51,
      category: {
        id: 'a48cc6cb-fe40-4cd6-bca7-bfbfd592e569',
        order: 4,
        name: 'Fracturen'
      }
    },
    {
      id: 'c133433d-4600-491a-a25a-9001a66fe940',
      defaultCampusId: [],
      name: 'Fractuur humeruskop',
      nomenclature: '296811',
      price: 0.93,
      category: {
        id: 'a48cc6cb-fe40-4cd6-bca7-bfbfd592e569',
        order: 4,
        name: 'Fracturen'
      }
    },
    {
      id: 'd61dae91-b0a1-4616-a203-d5361fa3f2b8',
      defaultCampusId: [],
      name: 'Fractuur olecranon',
      nomenclature: '296870',
      price: 0.74,
      category: {
        id: 'a48cc6cb-fe40-4cd6-bca7-bfbfd592e569',
        order: 4,
        name: 'Fracturen'
      }
    },
    {
      id: 'fafbcadb-40db-4333-bc78-8aa2309b281f',
      defaultCampusId: [],
      name: 'Fractuur proc. Cor.',
      nomenclature: '296656',
      price: 0.74,
      category: {
        id: 'a48cc6cb-fe40-4cd6-bca7-bfbfd592e569',
        order: 4,
        name: 'Fracturen'
      }
    },
    {
      id: '8df5a533-c276-4527-86f0-0b543bbd4a98',
      defaultCampusId: [],
      name: 'Spalk hand',
      nomenclature: '297135',
      price: 0.37,
      category: {
        id: 'f4551772-eea4-4f42-9010-6a3d0d4e84e8',
        order: 2,
        name: 'Gips'
      }
    },
    {
      id: '96e1da92-8dbc-424d-ba6a-e29c3f8b4d25',
      defaultCampusId: [],
      name: 'Gips pols',
      nomenclature: '297150',
      price: 0.47,
      category: {
        id: 'f4551772-eea4-4f42-9010-6a3d0d4e84e8',
        order: 2,
        name: 'Gips'
      }
    },
    {
      id: '9e574046-d3dd-4c0e-a988-015aaab50b2c',
      defaultCampusId: [],
      name: 'Spalk vinger',
      nomenclature: '297113',
      price: 0.19,
      category: {
        id: 'f4551772-eea4-4f42-9010-6a3d0d4e84e8',
        order: 2,
        name: 'Gips'
      }
    },
    {
      id: 'ca64e3a9-e7d9-46be-9f0a-374b40e1bb60',
      defaultCampusId: [],
      name: 'Gips elleboog',
      nomenclature: '2971972',
      price: 0.61,
      category: {
        id: 'f4551772-eea4-4f42-9010-6a3d0d4e84e8',
        order: 2,
        name: 'Gips'
      }
    },
    {
      id: 'd7cfeb2d-b378-4f1c-b2ac-e4758c87c65e',
      defaultCampusId: [],
      name: 'Gips vinger',
      nomenclature: '297113',
      price: 0.19,
      category: {
        id: 'f4551772-eea4-4f42-9010-6a3d0d4e84e8',
        order: 2,
        name: 'Gips'
      }
    },
    {
      id: '30f8fad5-f983-48ea-bb9a-79b9fd19630a',
      defaultCampusId: [],
      name: 'Verslag',
      nomenclature: '109012',
      price: 0.07,
      category: {
        id: 'fbae34df-83e2-4344-9670-e1b470cd9334',
        order: 1,
        name: 'Standaard'
      }
    },
    {
      id: '470921c5-db6f-487e-8c17-c5c4a4b4a4bb',
      defaultCampusId: ['3'],
      name: 'Consultatie 55 euro (Antw)',
      nomenclature: '102012',
      price: 0.55,
      category: {
        id: 'fbae34df-83e2-4344-9670-e1b470cd9334',
        order: 1,
        name: 'Standaard'
      }
    },
    {
      id: '56ea9c9e-6678-4305-8a98-842babb892e2',
      defaultCampusId: ['9'],
      name: 'Consultatie 70 euro (Kielse)',
      nomenclature: '102012',
      price: 0.7,
      category: {
        id: 'fbae34df-83e2-4344-9670-e1b470cd9334',
        order: 1,
        name: 'Standaard'
      }
    },
    {
      id: '822a7adf-1dd3-4b9b-b515-5fc63e8c6bbc',
      defaultCampusId: [],
      name: 'Consultatie 50 euro',
      nomenclature: '102012',
      price: 0.5,
      category: {
        id: 'fbae34df-83e2-4344-9670-e1b470cd9334',
        order: 1,
        name: 'Standaard'
      }
    },
    {
      id: '85544cd8-0779-4d9c-bc3d-5469d5c36702',
      defaultCampusId: [],
      name: 'Consultatie 80 euro',
      nomenclature: '102012',
      price: 0.8,
      category: {
        id: 'fbae34df-83e2-4344-9670-e1b470cd9334',
        order: 1,
        name: 'Standaard'
      }
    },
    {
      id: 'e57f02b2-e0b9-4e4f-a5b5-b9f1253f9457',
      defaultCampusId: ['5'],
      name: 'Consultatie 45 euro (Deurne)',
      nomenclature: '102012',
      price: 0.45,
      category: {
        id: 'fbae34df-83e2-4344-9670-e1b470cd9334',
        order: 1,
        name: 'Standaard'
      }
    }
  ]
};

//──── campuses list ─────────────────────────────────────────────────────────────────────
export const testCampusesList = [
  {
    address: 'Harmoniestraat 68, 2018 Antwerpen',
    email: 'acom@azmonica.be',
    externalId: 3,
    id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
    isAvailableQR: true,
    isHigherFees: false,
    name: 'Campus Antwerpen'
  },
  {
    address: 'Kielsevest 14, 2018 Antwerpen',
    email: 'kielsevest@azmonica.be',
    externalId: 9,
    id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
    isAvailableQR: true,
    isHigherFees: true,
    name: 'Private Campus Kielse Vest'
  },
  {
    address: 'Stevenslei 20, 2100 Deurne',
    email: 'ortho-spm@azmonica.be',
    externalId: 5,
    id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
    isAvailableQR: true,
    isHigherFees: false,
    name: 'Campus Deurne'
  }
];
